module.exports = __webpack_public_path__ + "img/photo-58.8ff0c421.webp";